import { IGame } from "../../entities";
import { provider } from "../../providers";

export interface UpdateGameScorePayload {
  gameId: number;
  hostScore: number;
  visitorScore: number;
}

export const UpdateGameScore = async (params: UpdateGameScorePayload): Promise<IGame> =>
  provider.Request("/games/score", params);
